import * as Yup from 'yup';

const phoneRegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export const PhoneNumberSchema = Yup.string()
  .required('Please enter your phone number')
  .matches(phoneRegExp, 'Must be a valid phone number');
